module.exports = __webpack_public_path__ + "243a68cb87b91ade5da1210f91220e52.svg";